import { useState, useEffect } from 'react'
import { supabase } from '../lib/supabase'

export default function PaginaGuida({ onChiudi }) {
  const [testo, setTesto] = useState('')
  const [caricamento, setCaricamento] = useState(true)

  useEffect(() => {
    supabase
      .from('impostazioni_app')
      .select('valore')
      .eq('chiave', 'guida')
      .maybeSingle()
      .then(({ data }) => {
        setTesto(data?.valore || '')
        setCaricamento(false)
      })
  }, [])

  return (
    <div style={{ flex: 1, display: 'flex', flexDirection: 'column' }} className="fade-in">
      <div className="topbar">
        <button className="back-btn" onClick={onChiudi}>&larr;</button>
        <div style={{ fontFamily: 'Syne', fontWeight: 700 }}>Guida all'app</div>
        <div style={{ width: 32 }} />
      </div>

      <div className="scroll-area">
        {caricamento ? (
          <div style={{ textAlign: 'center', color: 'var(--muted)', padding: 40 }}>Caricamento...</div>
        ) : (
          <>
            {testo.split('\n').map((riga, i) => {
              const isTitolo = riga === riga.toUpperCase() && riga.trim().length > 2 && !riga.includes('.')
              if (!riga.trim()) return <div key={i} style={{ height: 8 }} />
              if (isTitolo) return (
                <div key={i} style={{ fontFamily: 'Syne', fontWeight: 800, fontSize: 15, color: 'var(--accent)', marginTop: 20, marginBottom: 8 }}>
                  {riga}
                </div>
              )
              const isParagrafoConTitolo = riga.includes(' — ')
              if (isParagrafoConTitolo) {
                const [titolo, ...resto] = riga.split(' — ')
                return (
                  <div key={i} className="card" style={{ marginBottom: 10 }}>
                    <div className="card-body">
                      <div style={{ fontFamily: 'Syne', fontWeight: 700, fontSize: 13, marginBottom: 6, color: 'var(--text)' }}>{titolo}</div>
                      <div style={{ fontSize: 13, color: 'var(--muted)', lineHeight: 1.7 }}>{resto.join(' — ')}</div>
                    </div>
                  </div>
                )
              }
              return (
                <div key={i} style={{ fontSize: 13, color: 'var(--muted)', lineHeight: 1.7, marginBottom: 8 }}>{riga}</div>
              )
            })}
            <div style={{ textAlign: 'center', fontSize: 12, color: 'var(--muted)', paddingTop: 16 }}>
              FitProgress v3 · fitprogress.it
            </div>
          </>
        )}
      </div>
    </div>
  )
}
